import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultRowComponent = (_ref) => {
  let {
    trRef,
    requiredRowProps
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["trRef", "requiredRowProps", "row"]);

  return /*#__PURE__*/_jsx("tr", Object.assign({}, requiredRowProps, {
    ref: trRef
  }, rest));
};